/**
 * Pay-Easy Icon Data
 * Icon URL for Pay-Easy payment method (Japan bank transfer/ATM payments)
 */
export const PAYEASY_ICON_DATA_URL =
  'https://www.airwallex.com/docs/assets/contentful/images.ctfassets.net/c3n7jozh84hr/3DKc8YOvmllqXs9MIZvDFU/195c73003eacb07b60dd2740c59ab4e3/Pay-easy.svg';
